module.exports = __webpack_public_path__ + "img/logoMDcolor.b7ff7336.png";